// extracted by mini-css-extract-plugin
export default {"container":"EstimateActivity_container__alB3e","noDataAvailable":"EstimateActivity_noDataAvailable__O5aWa"};